module.exports = __webpack_public_path__ + "static/media/mind-blown.0c119d1e.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mind-blown.gif
// module id = 947
// module chunks = 0